import { styled, Popover } from "@mui/material";

export const StyledPopover = styled(Popover)({
  pointerEvents: "none",
}) as typeof Popover;
